<template>
  <div class="modal fade" tabindex="-1" id="modal_store_presc_prot">
    <div class="modal-dialog modal-xl">
      <form method="post" @submit.prevent="submitForm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ isInserting ? 'Adicionar' : 'Editar' }} Modelo de Prescrição</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label for="id_presc_prot_store" class="required form-label">Nome do modelo</label>
                <input class="form-control form-control-solid"
                       v-model="formStore.presc_prot_name" id="id_presc_prot_store" autofocus required>
                <small class="text-danger" v-if="formStoreErrors.presc_prot_name">{{ formStoreErrors.presc_prot_name[0] }}</small>
              </div>
              <div class="col-md-4">
                <label class="required form-label">Tipo de conteúdo</label>
                <select class="form-select form-control-solid" v-model="formStore.content_type" @change="onContentTypeChange">
                  <option v-for="(label, key) in contentTypes" :key="key" :value="key">{{ label }}</option>
                </select>
              </div>
              <div class="col-md-2 mt-12">
                <label for="presc_prot_active_store" class="form-label">Ativo?</label>
                <input class="form-check-input" type="checkbox" v-model="formStore.active" id="presc_prot_active_store" checked>
              </div>
            </div>

            <div class="row mt-4">
              <!-- So vale para modelo que nao e de medicamento: em medicamento
                   storeFromModel agrupa pelo tipo dos itens e ignora este. -->
              <div class="col-md-6" v-if="formStore.content_type !== 'medication'">
                <label class="form-label">Tipo legal padrão</label>
                <select class="form-select form-control-solid" v-model="formStore.id_presc_type_default">
                  <option value="">--Nenhum--</option>
                  <option :value="prescType.id_presc_type" v-for="prescType in prescTypes" :key="prescType.id_presc_type">
                    {{ prescType.presc_type_name }}
                  </option>
                </select>
              </div>
              <div :class="formStore.content_type === 'medication' ? 'col-md-4' : 'col-md-6'">
                <label class="form-label">Ordem</label>
                <input type="number" min="0" class="form-control form-control-solid" v-model.number="formStore.model_order">
              </div>
            </div>

            <PrescriptionModelOptionsEditor
                v-if="['grid', 'structured_list'].includes(formStore.content_type)"
                v-model="formStore.options"
                :content-type="formStore.content_type"
                :grid-presets="gridPresets"
                :structured-list-presets="structuredListPresets"
            />
          </div>

          <div class="card ms-4" v-if="formStore.content_type === 'medication'">
            <hr>
            <h5 class="card-title mt-6">Medicamentos</h5>
            <div class="card-body">
              <div class="col-md-12">
                <p class="presc-model-hint">
                  <i class="bi bi-info-circle"></i>
                  No medicamento, o receituário sai da substância. Na fórmula manipulada, você escolhe o tipo.
                </p>
                <PrescriptionDrugFields :drug="formStoreDrug"
                                        :drug-admins="drugAdmins"
                                        :errors="formStoreDrugErrors"
                                        id-prefix="model-drug"
                                        @catalog="applyCatalogDrug(formStoreDrug, $event)"
                                        @clear-catalog="clearCatalogLink(formStoreDrug)"/>

                <div class="col-md-4 mt-4">
                  <button type="button" v-if="!editingStore && hasPermission('Store Prescription Protocol Drug')" class="btn btn-primary" @click="addStoreDrug()">Incluir</button>
                  <button type="button" v-if="editingStore" class="btn btn-light me-2" @click="clearStoreDrug()">Cancelar</button>
                  <button type="button" v-if="editingStore && hasPermission('Update Prescription Protocol Drug')" class="btn btn-primary" @click="updStoreDrug()">Alterar</button>
                </div>

                <small class="text-danger" v-if="formStoreDrugErrors.drugs">{{ formStoreDrugErrors.drugs[0] }}</small>
                <div class="col-md-12 mb-6 mt-4">
                  <table class="table table-row-bordered table-hover table-light gy-3">
                    <thead>
                    <tr class="fw-bold fs-6 text-muted">
                      <th style="text-align: center">#</th>
                      <th>Medicamento</th>
                      <th>Posologia</th>
                      <th>Observação</th>
                      <th style="text-align: center">Receituário</th>
                      <th>Apresentação</th>
                      <th style="text-align: center">Administração</th>
                      <th style="text-align: center">Açoes</th>
                    </tr>
                    </thead>
                    <tr v-for="(drug, index) in formStore.drugs" :key="drug.id_presc_prot_drug">
                      <td style="text-align: center">{{ index + 1 }}</td>
                      <td style="white-space:pre-wrap; word-wrap:break-word">{{ drug.drug_name }}</td>
                      <td>{{ drug.dosage_desc }}</td>
                      <td style="white-space:pre-wrap; word-wrap:break-word">{{ drug.drug_obs }}</td>
                      <td style="text-align: center"><RegulatoryBadge :classification="badgeFor(drug)"/></td>
                      <td>{{ presentationSummary(drug) }}</td>
                      <td style="text-align: center">{{ drugAdmins.find((element) => { return element.id_drug_admin === drug.id_drug_admin })?.drug_admin_name }}</td>
                      <td style="text-align: center">
                        <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="hasPermission('Update Prescription Protocol Drug')"
                                data-bs-toggle="tooltip" title="Editar Opção" @click="edtStoreDrug(index);">
                          <i class="bi bi-pencil-square"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="hasPermission('Delete Prescription Protocol Drug')"
                                data-bs-toggle="tooltip" title="Excluir Opção" @click="delStoreDrug(index);">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </table>

                  <p v-if="modelSummary" class="presc-model-summary"
                     :class="{ 'is-warning': modelHasUnknown }">
                    <i class="bi" :class="modelHasUnknown ? 'bi-exclamation-triangle-fill' : 'bi-files'"></i>
                    {{ modelSummary }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            <button
                type="submit"
                :disabled="!hasPermission(isInserting ? 'Store Prescription Protocol' : 'Update Prescription Protocol')"
                class="btn btn-primary"
            >{{ isInserting ? 'Cadastrar' : 'Alterar' }}</button>
          </div>
        </div>
      </form>
    </div>
  </div> <!-- modal_store_presc_prot -->
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Permission from "../../helpers/permission";
import RegulatoryBadge from "@/views/attendance/shared/RegulatoryBadge.vue";
import PrescriptionDrugFields from "@/views/attendance/shared/PrescriptionDrugFields.vue";
import {loadRegulatoryTypes} from "@/helpers/regulatoryTypes";
import PrescriptionModelOptionsEditor from "./components/PrescriptionModelOptionsEditor.vue";

export default {
  name: "PrescriptionProtocolDrugs",
  components: {PrescriptionDrugFields, PrescriptionModelOptionsEditor, RegulatoryBadge},
  props: {
    prescProt: Object,
    prescTypes: Array,
    drugAdmins: Array,
    currentProfessionalId: Number,
    contentTypes: Object,
    gridPresets: Object,
    structuredListPresets: Object,
  },
  data() {
    return {
      formStore: {
        id_presc_prot: '',
        presc_prot_name: '',
        active: true,
        content_type: 'medication',
        options: null,
        id_presc_type_default: '',
        model_order: 0,
        drugs: [],
      },
      formStoreErrors: [],
      editingStore: false,
      indexStoreDrug: '',
      formStoreDrug: {
        id_presc_prot_drug: '',
        id_presc_prot: '',
        id_presc_type: '',
        item_kind: 'medication',
        id_drug_admin: '',
        drug_name: '',
        id_drug: null,
        concentration: '',
        pharmaceutical_form: '',
        quantity: '',
        measure: '',
        composition: '',
        regulatory_type: 'SIMPLES',
        continuous_use: false,
        monthly_quantity: '',
        dosage_desc: '',
        treatment_time: '',
        drug_obs: '',
      },
      formStoreDrugErrors: [],
    }
  },
  computed: {
    /**
     * O tipo legado deixou de ser escolha do medico (7.7.5): o receituario sai
     * da substancia na emissao. Ele continua indo para a API porque
     * importProtocol agrupa os itens por ele — um valor so para o modelo
     * inteiro faz o modelo gerar uma prescricao, e a quebra por tipo acontece
     * onde deve, no motor regulatorio.
     */
    /** Itens sem vinculo com o catalogo: o modelo antigo nao tem id_drug. */
    modelHasUnknown() {
      return (this.formStore.drugs ?? []).some((drug) => drug.regulatory_status !== 'CLASSIFIED');
    },
    modelSummary() {
      const itens = this.formStore.drugs ?? [];

      if (this.formStore.content_type !== 'medication' || itens.length === 0) {
        return '';
      }

      const pendentes = itens.filter((drug) => drug.regulatory_status !== 'CLASSIFIED').length;

      if (pendentes > 0) {
        return pendentes === itens.length
            ? 'Nenhum item deste modelo está vinculado ao catálogo. O receituário terá de ser escolhido a cada uso.'
            : `${pendentes} de ${itens.length} itens não estão vinculados ao catálogo. O receituário deles terá de ser escolhido a cada uso.`;
      }

      const tipos = new Set(itens.map((drug) => drug.regulatory_type).filter(Boolean));

      return tipos.size === 1
          ? 'Este modelo vai gerar 1 documento.'
          : `Este modelo vai gerar ${tipos.size} documentos, um por tipo de receituário.`;
    },
    legacyPrescTypeId() {
      if (this.formStore.id_presc_type_default) {
        return this.formStore.id_presc_type_default;
      }

      const tipos = this.prescTypes ?? [];

      return (tipos.find((tipo) => !tipo.presc_type_special) ?? tipos[0])?.id_presc_type ?? '';
    },
    isInserting() {
      return this.prescProt?.id_presc_prot == null;
    }
  },
  mounted() {
    loadRegulatoryTypes().catch(() => {});
  },
  watch: {
    prescProt(newPrescProt, oldPrescProte) {
      if (newPrescProt)
        this.formStore = newPrescProt
      else
        this.clearStoreForm();
      this.clearStoreDrug();
    }
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    badgeFor(drug) {
      if (!drug.regulatory_status) {
        return null;
      }

      return {
        status: drug.regulatory_status,
        regulatory_type: drug.regulatory_type ?? null,
        regulatory_type_description: drug.regulatory_type_description ?? null,
        reason_description: 'Sem classificação: o receituário terá de ser escolhido na hora de prescrever.',
        manual: false,
      };
    },
    applyCatalogDrug(form, drug) {
      form.id_drug = drug.id_drug;
      form.drug_name = drug.drug_name;
      form.concentration = drug.concentration ?? '';
      form.pharmaceutical_form = drug.pharmaceutical_form ?? '';
      form.regulatory_status = drug.regulatory_status ?? null;
      form.regulatory_type = drug.regulatory_type ?? null;
      form.regulatory_type_description = drug.regulatory_type_description ?? null;
    },
    // Concentração e forma continuam: no manipulado elas costumam valer, o que
    // deixa de valer é o vínculo com o item industrializado do catálogo.
    clearCatalogLink(form) {
      form.id_drug = null;
      form.regulatory_status = null;
      if (form.item_kind === 'compounded') {
        return;
      }
      form.regulatory_type = null;
      form.regulatory_type_description = null;
    },
    clearStoreForm() {
      this.formStore = {
        id_presc_prot: '',
        presc_prot_name: '',
        active: true,
        content_type: 'medication',
        options: null,
        id_presc_type_default: '',
        model_order: 0,
        drugs: [],
      }
    },
    onContentTypeChange() {
      if (this.formStore.content_type !== 'medication') {
        this.formStore.drugs = [];
      }
      if (!['grid', 'structured_list'].includes(this.formStore.content_type)) {
        this.formStore.options = null;
      }
    },
    submitForm() {
      if (this.isInserting)
        this.submitFormStore();
      else
        this.submitFormEdit();
    },
    hasDrugs() {
      if (this.formStore.content_type !== 'medication') {
        return true;
      }
      if (this.formStore?.drugs?.length === 0) {
        Alert.toastError("Modelo de medicamentos deve ter no mínimo um item.");
        return false;
      }
      return true;
    },
    submitFormStore() {
      this.formStoreErrors = [];
      if (this.hasDrugs()) {
        http.post(`/professionals/${this.currentProfessionalId}/prescription-models`, this.formStore).then(_ => {
          Alert.toastSuccess("Modelo cadastrado com sucesso.");
          this.clearStoreForm();
          bootstrap.Modal.getInstance(document.getElementById('modal_store_presc_prot')).toggle();
          this.$emit('onClose');
        }).catch(e => {
          Alert.toastError(e.response.data.message??e.response.data);
          if (e.response.data.errors) {
            this.formStoreErrors = e.response.data.errors;
          }
        });
      }
    },
    submitFormEdit() {
      this.formEditErrors = [];
      if (this.hasDrugs()) {
        http.put(`/professionals/${this.currentProfessionalId}/prescription-models/${this.formStore.id_presc_prot}`, this.formStore).then(() => {
          Alert.toastSuccess("Modelo atualizado com sucesso.");
          bootstrap.Modal.getInstance(document.getElementById('modal_store_presc_prot')).toggle();
          this.$emit('onClose');
        }).catch(e => {
          Alert.toastError(e.response.data.message??e.response.data);
          if (e.response.data.errors) {
            this.formEditErrors = e.response.data.errors;
          }
        });
      }
    },
    clearStoreDrug() {
      this.formStoreDrug =
          {
            id_presc_prot_drug: '',
            id_presc_prot: '',
            id_presc_type: '',
            item_kind: 'medication',
            id_drug_admin: '',
            drug_name: '',
            id_drug: null,
            concentration: '',
            pharmaceutical_form: '',
            quantity: '',
            measure: '',
            composition: '',
            regulatory_type: 'SIMPLES',
            continuous_use: false,
        monthly_quantity: '',
            dosage_desc: '',
            treatment_time: '',
            drug_obs: '',
          };
      this.editingStore = false;
    },
    addStoreDrug() {
      if (this.validateFormDrug()) {
        this.formStore.drugs.push({
          ...this.formStoreDrug,
          id_presc_type: this.legacyPrescTypeId,
        });
        this.clearStoreDrug();
      }
    },
    presentationSummary(drug) {
      if (drug.item_kind === 'compounded') {
        return [drug.pharmaceutical_form, [drug.quantity, drug.measure].filter(Boolean).join(' ')].filter(Boolean).join(' · ');
      }
      return [drug.concentration, drug.pharmaceutical_form, drug.quantity, drug.treatment_time]
          .filter(Boolean)
          .join(' · ');
    },
    edtStoreDrug(index) {
      this.formStoreDrug.id_presc_prot_drug = this.formStore.drugs[index].id_presc_prot_drug;
      this.formStoreDrug.id_presc_type      = this.formStore.drugs[index].id_presc_type;
      this.formStoreDrug.item_kind          = this.formStore.drugs[index].item_kind ?? 'medication';
      this.formStoreDrug.id_drug_admin      = this.formStore.drugs[index].id_drug_admin;
      this.formStoreDrug.drug_name          = this.formStore.drugs[index].drug_name;
      this.formStoreDrug.measure            = this.formStore.drugs[index].measure ?? '';
      this.formStoreDrug.composition        = this.formStore.drugs[index].composition ?? '';
      this.formStoreDrug.regulatory_type    = this.formStore.drugs[index].regulatory_type ?? 'SIMPLES';
      this.formStoreDrug.id_drug            = this.formStore.drugs[index].id_drug ?? null;
      this.formStoreDrug.concentration      = this.formStore.drugs[index].concentration ?? '';
      this.formStoreDrug.pharmaceutical_form = this.formStore.drugs[index].pharmaceutical_form ?? '';
      this.formStoreDrug.quantity           = this.formStore.drugs[index].quantity ?? '';
      this.formStoreDrug.continuous_use     = this.formStore.drugs[index].continuous_use ?? false;
      this.formStoreDrug.dosage_desc        = this.formStore.drugs[index].dosage_desc;
      this.formStoreDrug.treatment_time     = this.formStore.drugs[index].treatment_time ?? '';
      this.formStoreDrug.drug_obs           = this.formStore.drugs[index].drug_obs ?? '';
      this.indexStoreDrug = index;
      this.editingStore = true;
      this.$refs.drugNameDrugStore.focus();
    },
    delStoreDrug (index) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o medicamento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.formStore.drugs.splice(index,1);
          this.clearStoreDrug();
        }
      });
    },
    updStoreDrug() {
      this.formStoreDrug.id_presc_type = this.legacyPrescTypeId;
      this.formStore.drugs[this.indexStoreDrug] = this.formStoreDrug;
      this.clearStoreDrug();
    },
    validateFormDrug() {
      this.formStoreDrugErrors = [];
      var error = false;

      const formula = this.formStoreDrug.item_kind === 'compounded';
      if (formula) {
        if ((this.formStoreDrug.drug_name ?? '').trim().length < 3) { error = true; this.formStoreDrugErrors.drug_name = ['Informe o nome da fórmula.']; }
        if (!(this.formStoreDrug.pharmaceutical_form ?? '').trim()) { error = true; this.formStoreDrugErrors.pharmaceutical_form = ['Selecione a forma física.']; }
        if (!(this.formStoreDrug.quantity ?? '').trim()) { error = true; this.formStoreDrugErrors.quantity = ['Informe a quantidade.']; }
        if (!(this.formStoreDrug.measure ?? '').trim()) { error = true; this.formStoreDrugErrors.measure = ['Selecione a medida.']; }
        if ((this.formStoreDrug.composition ?? '').trim().length < 3) { error = true; this.formStoreDrugErrors.composition = ['Informe a composição.']; }
        if ((this.formStoreDrug.dosage_desc ?? '').trim().length < 3) { error = true; this.formStoreDrugErrors.dosage_desc = ['Informe a posologia.']; }
        if (!this.formStoreDrug.regulatory_type) { error = true; this.formStoreDrugErrors.regulatory_type = ['Selecione o tipo de receituário.']; }
      } else if (!this.formStoreDrug.id_drug_admin) { error = true; this.formStoreDrugErrors.id_drug_admin = [ "A via de administração é obrigatória!" ]; }

      return ! error;
    }
  },
}
</script>

<style scoped>
.presc-model-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  border-left: 3px solid #780f5a;
  border-radius: 8px;
  padding: 10px 14px;
  margin: 8px 0 0;
  color: #495057;
  font-weight: 600;
}

.presc-model-summary.is-warning {
  background: #fff9db;
  border-left-color: #e0a800;
}

.presc-model-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  border-left: 3px solid #780f5a;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  color: #495057;
}
</style>